import React from 'react';

export default () => <hr className = 'overflow-menu-hr' />;
